<template>
  <b-navbar class="fixed-top shadow-lg" toggleable="md" type="dark" variant="dark" v-b-scrollspy="config">
    <b-navbar-brand class="text-white-50" href="#top">
      <b-img rounded v-bind="propo" src="@/assets/tree.jpg"/>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item href="#about" >About</b-nav-item>
        <b-nav-item href="#skill">Skills</b-nav-item>
        <b-nav-item href="#exp">Experience</b-nav-item>
        <b-nav-item href="#edu">Education</b-nav-item>
        <b-nav-item href="#proj">Projects</b-nav-item>
        <b-nav-item href="#contact" >Contact Me</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'NavBar',
  data () {
    return {
      propo: { height: 30 },
      config: {
        offset: 65
      }
    }
  }
}
</script>

<style>
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
